'use strict';
var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/is-object.js
// module id = 49
// module chunks = 0